import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=477122ca"
import script from "./CourseIndex.vue?vue&type=script&lang=ts"
export * from "./CourseIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports